import React from "react";
//user icon
import {AiOutlineUser, AiOutlineMail} from 'react-icons/ai';
import {BsBoxSeam} from 'react-icons/bs';
import {FaRegAddressCard} from 'react-icons/fa';
import { HiOutlineLocationMarker } from "react-icons/hi";
import { useAuth } from "../../Context/Auth";
import {BiTrash} from 'react-icons/bi';
//get props from router
import { useParams } from "react-router-dom";
import Address from "./address";
import Profile from "./profile";
import DropShipping from "./dropshipping";
import Orders from "./orders";
import Support from "./support";

export default function ProfileScreen() {
    const { user } = useAuth();
    const { tab } = useParams();

    const menuItems = [
        { id: 'profile', icon: AiOutlineUser, label: 'Mi Perfil', href: '/me/profile' },
        { id: 'orders', icon: BsBoxSeam, label: 'Mis Pedidos', href: '/me/orders' },
        { id: 'address', icon: HiOutlineLocationMarker, label: 'Mis Direcciones', href: '/me/address' },
        { id: 'dropshipping', icon: FaRegAddressCard, label: 'DropShipping', href: '/me/dropshipping' },
        { id: 'help', icon: AiOutlineMail, label: 'Atención al cliente', href: '/me/help', notification: 1 },
        { id: 'delete', icon: BiTrash, label: 'Eliminar Cuenta', href: '/me/delete', isDanger: true },
    ];

    const isActive = (itemId) => {
        if (!tab || tab === 'profile') return itemId === 'profile';
        return tab === itemId;
    };

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#f9fafb',
            padding: '16px'
        }}>
            <div style={{
                maxWidth: '1400px',
                margin: '0 auto',
                display: 'grid',
                gridTemplateColumns: window.innerWidth > 768 ? '280px 1fr' : '1fr',
                gap: window.innerWidth > 768 ? '32px' : '16px'
            }}>
                {/* Sidebar */}
                <div style={{
                    backgroundColor: '#fff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '12px',
                    padding: window.innerWidth > 768 ? '24px' : '16px',
                    height: 'fit-content',
                    position: window.innerWidth > 768 ? 'sticky' : 'relative',
                    top: window.innerWidth > 768 ? '32px' : '0',
                    overflowX: window.innerWidth > 768 ? 'visible' : 'auto'
                }}>
                    {window.innerWidth > 768 && (
                        <h2 style={{
                            fontSize: '20px',
                            fontWeight: '700',
                            color: '#111827',
                            margin: '0 0 24px 0',
                            fontFamily: 'Inter, sans-serif'
                        }}>
                            Mi cuenta
                        </h2>
                    )}

                    <div style={{
                        display: 'flex',
                        flexDirection: window.innerWidth > 768 ? 'column' : 'row',
                        gap: '8px',
                        flexWrap: 'nowrap',
                        width: '100%'
                    }}>
                        {menuItems.map((item) => {
                            const Icon = item.icon;
                            const active = isActive(item.id);

                            return (
                                <a
                                    key={item.id}
                                    href={item.href}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        padding: window.innerWidth > 768 ? '12px 16px' : '10px 14px',
                                        borderRadius: '8px',
                                        textDecoration: 'none',
                                        backgroundColor: active ? '#f0fdf4' : 'transparent',
                                        border: active ? '1px solid #bbf7d0' : '1px solid transparent',
                                        color: item.isDanger && !active ? '#dc2626' : active ? '#028322' : '#6b7280',
                                        fontSize: window.innerWidth > 768 ? '14px' : '13px',
                                        fontWeight: active ? '600' : '500',
                                        fontFamily: 'Inter, sans-serif',
                                        transition: 'all 0.2s ease',
                                        position: 'relative',
                                        whiteSpace: window.innerWidth > 768 ? 'normal' : 'nowrap',
                                        flexShrink: window.innerWidth > 768 ? 0 : 0
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!active) {
                                            e.currentTarget.style.backgroundColor = '#f9fafb';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!active) {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                        }
                                    }}
                                >
                                    <Icon size={20} />
                                    <span style={{ flex: 1 }}>{item.label}</span>
                                    {item.notification && (
                                        <span style={{
                                            backgroundColor: '#028322',
                                            color: '#fff',
                                            borderRadius: '50%',
                                            width: '20px',
                                            height: '20px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '12px',
                                            fontWeight: '700'
                                        }}>
                                            {item.notification}
                                        </span>
                                    )}
                                </a>
                            );
                        })}
                    </div>
                </div>

                {/* Content */}
                <div style={{
                    backgroundColor: '#fff',
                    border: '1px solid #e5e7eb',
                    borderRadius: '12px',
                    padding: window.innerWidth > 768 ? '32px' : '16px',
                    minHeight: '600px'
                }}>
                    {tab === undefined || tab === 'profile' ? <Profile/> :
                     tab === 'orders' ? <Orders/> :
                     tab === 'address' ? <Address/> :
                     tab === 'dropshipping' ? <DropShipping/> :
                     tab === 'help' ? <Support/> : <Profile/>}
                </div>
            </div>
        </div>
    );
}